module.exports = __webpack_public_path__ + "img/Football.6532c34c.png";